import React, { useState } from 'react';
import ChangeTierModal from 'components/payment/ChangeTierModal.jsx';

// The call-to-action shown on a tier card for an active subscriber who is on a
// tier plan. `state` is computed server-side relative to the subscriber's own
// tier: 'current' (their plan — no action), 'upgrade' or 'downgrade'. `className`
// overrides the button styling (and drops the centering) so the in-app paywall's
// PricingCards can render it as a full-width pricing-card button; it defaults to
// the pricing-page style so existing callers are unchanged.
const ChangeTierButton = ({ targetTier, targetTierName, state, className }) => {
  const [open, setOpen] = useState(false);
  const buttonClass = className || 'btn btn-price simple-btn';

  if (state === 'current') {
    return (
      <span className={`${buttonClass} subscription-card-current`} aria-disabled="true">
        {t('payment.current_plan')}
      </span>
    );
  }

  // Name the tier being moved to. A row of buttons all reading "Upgrade" tells a subscriber
  // nothing about where each one takes them. The JS t() does no interpolation, so replace
  // the placeholder the way the rest of the codebase does.
  const label = (state === 'downgrade'
    ? t('payment.change_tier_downgrade_cta')
    : t('payment.change_tier_upgrade_cta')
  ).replace('%{tier}', targetTierName);

  const cta = (
    <a
      className={buttonClass}
      href="#"
      onClick={(event) => { event.preventDefault(); setOpen(true); }}
    >
      {label}
    </a>
  );

  return (
    <span>
      {className ? cta : <center>{cta}</center>}
      {open && (
        <ChangeTierModal
          targetTier={targetTier}
          targetTierName={targetTierName}
          direction={state}
          onClose={() => setOpen(false)}
          onSuccess={() => window.location.reload()}
        />
      )}
    </span>
  );
};

export default ChangeTierButton;
